import { debounce } from './debounce';
import { validator } from './regex';

export const textareaHandler = (textAreaWrapper, cb) => {

  if (!textAreaWrapper) return;

  const textArea = textAreaWrapper.querySelector('textarea');

  if (!textArea) return;

  const errorMsg = textAreaWrapper.querySelector('[data-error]');

  const isRequired = textArea.getAttribute('required') === 'true';

  textArea.addEventListener('input', (e) => {
    if (e.isComposing || e.keyCode === 229) return;
    textArea.classList.remove('input_error');
    if (errorMsg && isRequired) errorMsg.classList.add('hidden');
  });

  textArea.addEventListener('keyup', debounce((e) => {
    if (e.isComposing || e.keyCode === 229) return;

    if (isRequired && errorMsg) {
      const isValid = validator(e?.target.value, 'text');
      isValid ? textArea.classList.remove('input_error') : textArea.classList.add('input_error');
      isValid ? errorMsg.classList.add('hidden') : errorMsg.classList.remove('hidden');
    }

    cb?.(e?.target.value);
  }, 500));
};
